export default __webpack_public_path__ + "static/media/MenuDiv.795e0fd4.svg";